<template>
   <div class="fixed_btn">
         <div class="back-to-top" @click="backToTop" v-show="showReturnToTop" @mouseenter="show" @mouseleave="hide">
            <!--<img  :class="[bttOption.iClass]" :nuoxin="{color:bttOption.iColor,'font-size':bttOption.iFontsize}" src="@/assets/image/goTop.png" alt="">-->
            <div  class="goTopitem item"></div>
         </div>
       <div class="back-to-top wx"  v-show="showReturnToTop" @mouseenter="showCode" @mouseleave="hideCode">
         <!--<img  :class="[bttOption.iClass]" :nuoxin="{color:bttOption.iColor,'font-size':bttOption.iFontsize}" src="@/assets/image/wx.png" alt="">-->
         <div  class="wxitem item"></div>
       </div>
        <Wxhover :direction = "direction" :allCode="allCode" :postionStyle="false"/>
       <div class="back-to-top  call" v-show="showReturnToTop">
         <div class="callitem item"  @mouseenter="showCall" @mouseleave="hideCall"></div>
         <!--<img  :class="[bttOption.iClass]" :nuoxin="{color:bttOption.iColor,'font-size':bttOption.iFontsize}" src="@/assets/image/call.png" alt="">-->
         <span></span>
         <div class="number_show" v-show="isCallShow">
           <div><span class="number_tip">服务热线：</span><span class="number">13696802066</span></div>
           <div class="data_time">周一至周五08:30-17:30</div>
         </div>
       </div>
   </div>
</template>

<script>
  import   ScrollTool   from '@/assets/Utils/scrollTool';
  import   Wxhover from './Wxhover';
  export default {
    name: 'ScrollTop',
    props: {
      text: { // 文本提示
        type: String,
        default: '返回顶部'
      },
      textColor: { // 文本颜色
        type: String,
        default: '#f00'
      },
      iPos: { // 文本位置
        type: String,
        default: 'right'
      },
      iClass: { // 图标形状
        type: String,
        default: 'fzicon fz-ad-fanhuidingbu1'
      },
      iColor: { // 图标颜色
        type: String,
        default: '#f00'
      },
      iFontsize: { // 图标大小
        type: String,
        default: '32px'
      },
      pageY: { // 默认在哪个视图显示返回按钮
        type: Number,
        default: 400
      },
      transitionName: { // 过渡动画名称
        type: String,
        default: 'easeInOutCubic'
      }
    },
    components:{
      Wxhover
    },
    data: function () {
      return {
        showTooltips: false,
        showReturnToTop: false,
        isCallShow:false,
        direction:"right",
        allCode:false
      }
    },
    computed: {
      bttOption () {
        return {
          text: this.text,
          textColor: this.textColor,
          iPos: this.iPos,
          iClass: this.iClass,
          iColor: this.iColor,
          iFontsize: this.iFontsize
        }
      }
    },
    methods: {
      hideCall(){
        this.isCallShow = false;
      },
      showCall(){
        this.isCallShow = true;
      },
      show () { // 显示隐藏提示文字
        return this.showTooltips = true;
      },
      hide () {
        return this.showTooltips = false;
      },
      currentPageYOffset () {
        // 判断滚动区域大于多少的时候显示返回顶部的按钮
        window.pageYOffset > this.pageY ? this.showReturnToTop = true : this.showReturnToTop = false;

      },
      backToTop () {
        ScrollTool(0, 1500, this.transitionName, this.currentPageYOffset);
      },
      showCode(){
          this.allCode = true;
      },
      hideCode(){
        this.allCode = false;
      }


    },
    created () {
      window.addEventListener('scroll', this.currentPageYOffset);
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.currentPageYOffset)
    }
  }
</script>

<style scoped lang="less">
  .fixed_btn {
    position: fixed;
    bottom: 12%;
    right: 30px;
    z-index: 9999;
    cursor: pointer;
    width: 50px!important;
      .item{
        margin-top: 5px;
      }
  }
  .goTopitem{
     width: 50px;
     height: 50px;
     background: url("~@/assets/image/goTop.png") no-repeat center center;
     background-size: cover;
      &:hover{
      background: url("~@/assets/image/gotop_hover.png") no-repeat center center;
        background-size: cover;
    }
  }
  .wxitem{
    width: 50px;
    height: 50px;
    background: url("~@/assets/image/wx.png") no-repeat center center;
    background-size: cover;
    &:hover{
      background: url("~@/assets/image/wx_hover.png") no-repeat center center;
      background-size: cover;
    }
  }
  .callitem{
    width: 50px;
    height: 50px;
    background: url("~@/assets/image/call.png") no-repeat center center;
    background-size: cover;
    &:hover{
      background: url("~@/assets/image/call_hover.png") no-repeat center center;
      background-size: cover;
    }
  }

  .number_show{
    position: fixed;
    bottom: 11%;
    right: 100px;
    padding: 14px 12px;
    background-color: #fff;
    z-index: 9999999999999999999999;
     color: #39B2EC;
    font-size:12px;
    line-height:16px;
    vertical-align: middle;
    box-shadow:0px 3px 16px 1px rgba(0,0,0,0.1);
    .number{
       font-size: 18px;
    }
    .data_time{
      font-weight:400;
      color:rgba(179,179,179,1);
      margin-top: 8px;
    }
    .number_tip{
        vertical-align: top;
    }
    &&::after{
      content: "";
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-left: 10px solid #fff;
      border-bottom: 10px solid transparent;
      position: absolute;
      top:50%;
      right:-10px;
      margin-top: -6px;
    }
  }
</style>
